import _toConsumableArray from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import { styled } from "./chunk-E32MZNBA.mjs";

// src/factory.ts
function factory() {
  var cache = /* @__PURE__ */new Map();
  return new Proxy(styled, {
    apply: function apply(target, thisArg, argArray) {
      return styled.apply(void 0, _toConsumableArray(argArray));
    },
    get: function get(_, element) {
      if (!cache.has(element)) {
        cache.set(element, styled(element));
      }
      return cache.get(element);
    }
  });
}
var chakra = factory();
export { chakra };